import React from 'react';
import { CheckIcon } from 'src/components/Icons';
import * as Ui from './styles';

export default function Tabs({ title, description, handleClick, isActive, isCompleted }) {

  return (
    <Ui.Container onClick={handleClick} isActive={isActive} isCompleted={isCompleted}>
      <h1>
        {isCompleted && <CheckIcon />}
        {title}
      </h1>
      {isCompleted && <Ui.Tag>CONCLUÍDO</Ui.Tag>}
      <Ui.Line isActive={isActive} />
      <p>
        {description}
      </p>
      {isActive && <div className="activeTriangle"></div>}
    </Ui.Container>
  );
}
